import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import userTokenService from '../../common/services/security/userTokenService';

const ProjectPermissionRoute = ({
  isAuthorized,
  permissions,
  component: Component,
  fallbackRoute,
  forceRefresh = false,
  componentProps = {},
  ...rest
}) => (
  <Route
    {...rest}
    render={({ match, location }) => {
      const { projectId } = match.params;
      if (!isAuthorized()) {
        return (
          <Redirect
            to={{
              pathname: fallbackRoute,
              state: { from: location },
            }}
          />
        );
      }

      if (projectId) {
        const hasPermission = userTokenService.hasProjectTokenProp(
          projectId,
          permissions
        );

        if (hasPermission) {
          return (
            <Component
              key={forceRefresh ? location.key : undefined}
              {...componentProps}
            />
          );
        }
      }

      return (
        <Redirect
          to={{
            pathname: '/unauthorized',
            state: { from: location },
          }}
        />
      );
    }}
  />
);

ProjectPermissionRoute.propTypes = {
  permissions: PropTypes.arrayOf(PropTypes.string),
  fallbackRoute: PropTypes.string,
};

ProjectPermissionRoute.defaultProps = {
  permissions: [],
  fallbackRoute: '/',
};

export default ProjectPermissionRoute;
